import { useCallback, useMemo } from 'preact/hooks';

const getByPath = (obj, path) => {
    if (!obj || !path) return undefined;
    return path.split('.').reduce((acc, key) => acc?.[key], obj);
};

export function useSortAndPage(items, sorting, pagination) {
    const { field = 'createdAt', direction = 'desc' } = sorting || {};
    const { pageNumber = 1, pageSize = 10 } = pagination || {};

    const comparator = useCallback(
        (a, b) => {
            let av = getByPath(a, field);
            let bv = getByPath(b, field);

            const iso = /^\d{4}-\d{2}-\d{2}T/;
            if (typeof av === 'string' && iso.test(av)) av = new Date(av);
            if (typeof bv === 'string' && iso.test(bv)) bv = new Date(bv);

            if (av instanceof Date) av = av.getTime();
            if (bv instanceof Date) bv = bv.getTime();
            if (typeof av === 'string') av = av.toLowerCase();
            if (typeof bv === 'string') bv = bv.toLowerCase();

            if (av == null && bv == null) return 0;
            if (av == null) return direction === 'asc' ? -1 : 1;
            if (bv == null) return direction === 'asc' ? 1 : -1;

            const cmp = av > bv ? 1 : av < bv ? -1 : 0;
            return direction === 'asc' ? cmp : -cmp;
        },
        [field, direction]
    );

    const sorted = useMemo(() => {
        if (!Array.isArray(items) || items.length === 0) return [];
        return [...items].sort(comparator); // never mutate original
    }, [items, comparator]);

    const total = sorted.length;

    const rows = useMemo(() => {
        if (total === 0) return [];
        const start = (pageNumber - 1) * pageSize;
        return sorted.slice(start, start + pageSize);
    }, [sorted, pageNumber, pageSize, total]);

    return { sorted, rows, total };
}
